/**
 * Wave 351 · Metrics schemas — client-side event recording.
 * CRITICAL: schema does NOT include tenantId/userId. Those come from auth on server.
 */

import { z } from 'zod';

// ═══════════════════════════════════════════════════════════════════════════════
// Event Names
// ═══════════════════════════════════════════════════════════════════════════════

export const MetricsEventNameSchema = z.enum([
  'taps_to_action',
  'time_to_first_action',
  'completion_rate',
  'abandoned_drafts',
  'offline_sync_age',
  'inbox_action_rate',
]);
export type MetricsEventName = z.infer<typeof MetricsEventNameSchema>;

// ═══════════════════════════════════════════════════════════════════════════════
// Metrics Event DTO
// ═══════════════════════════════════════════════════════════════════════════════

export const MetricsEventDTOSchema = z.object({
  event: MetricsEventNameSchema,
  context: z
    .record(z.unknown())
    .optional()
    .describe('Arbitrary context, capped at 4kb stringified'),
});
export type MetricsEventDTO = z.infer<typeof MetricsEventDTOSchema>;
